class ProductCarousel extends SlideshowComponent {
  constructor() {
    super();
    this.slider = this.querySelector('.carousel.slider.slider--desktop.slider--tablet');

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.initialize();
  }

  initialize() {
    this.querySelectorAll('#addToCart').forEach((button) => {
      button.addEventListener('click', () => {
        const productHandle = button.dataset.productHandle;
        const variantCount = Number(button.dataset.productVariantCount);
        const variantId = button.dataset.productVariantId;

        if (variantCount > 1) {
          window.location.assign(`/products/${productHandle}`);
        } else {
          this.addToCart(button, variantId);
        }
      });
    });
  }

  async addToCart(element, variantId) {
    try {
      element.setAttribute('disabled', 'disabled');
      element.classList.add('loading');
      element.querySelector('.loading__spinner').classList.remove('hidden');

      const formData = this.buildFormData(variantId);
      const standardCart = new StandardCart(this, formData);
      const cart = await standardCart.addToCart();
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Sorry, there was an error adding this item to your cart. Please try again.');
    } finally {
      element.removeAttribute('disabled');
      element.classList.remove('loading');
      element.querySelector('.loading__spinner').classList.add('hidden');
    }
  }

  buildFormData(variantId) {
    const form = document.createElement('form');
    const variantIdInput = Object.assign(document.createElement('input'), { type: 'hidden', name: 'id' });
    variantIdInput.value = variantId;
    form.appendChild(variantIdInput);
    const formData = new FormData(form);

    return formData;
  }

  async refreshCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Dispatch cart updated event
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart },
        })
      );
      return cart;
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
    return null;
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel);
}
